import React, { createContext, useState, useContext } from 'react';

// Crea il contesto
const LoaderContext = createContext();

// Fornisci il contesto per tutta l'app
export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [loaderType, setLoaderType] = useState('default'); // Tipo di loader

  const showLoader = (type = 'default') => {
    setLoaderType(type);
    setLoading(true);
  }

  const hideLoader = () => setLoading(false);

  return (
    <LoaderContext.Provider value={{ loading, loaderType, showLoader, hideLoader }}>
      {children}
    </LoaderContext.Provider>
  );
};

// Usa il contesto
export const useLoader = () => {
  return useContext(LoaderContext);
};
